<!-- CONTAINER -->
<div class="bg-white py-36px px-24px rounded-tl-[24px] rounded-tr-[24px]">
	<!-- HEADER SECTION -->

	<!-- filter -->
	<app-search-filter
		searchKey="STORE.PRODUCT_LIST.SEARCH"
		(toggleFilter)="sidenav.toggle()"
		(keyWord)="searchTextChanged($event)"
		[filterCount]="filterCount"
		(resetFilter)="filter.resetFilter()"
		[previousSearchText]="
			this.productFilter.searchText ? this.productFilter.searchText : ''
		"
	></app-search-filter>

	<!-- COUNTRIES -->
	<div
		class="max-w-[406px] flex justify-evenly items-center py-[8px] max-mobile:p-0 px-[10px] bg-off-white rounded-[50px] text-dark-grey mt-[18px] text-font-16 cursor-pointer border-secondry-color-Gray border-[1px]"
	>
		<a
			(click)="countryChange(country.id)"
			routerLink="/layout/store/products"
			[queryParams]="{ country: country.id }"
			*ngFor="let country of activeCountries"
			class="text-center w-[55%] max-mobile:m-[3px]"
			[ngClass]="{ activeClass: productFilter.countryId == country.id }"
		>
			<!-- prettier-ignore -->
			<img class="inline-block w-[24px] max-mobile:hidden max-mobile:w-full max-mobile:text-font-mobile-small" [src]="attachmentURL + country.flagUrl" alt="" />
			{{
				this.translate.currentLang === 'ar'
					? country?.name?.ar
					: country?.name?.en
			}}
		</a>
	</div>
	<!-- prettier-ignore -->
	<!-- tabs -->
	<div class="my-[18px] overflow-auto flex justify-between">
		<app-tabs
			[taps]="productTabs"
			(tapChanged)="tapChanged($event)"
			[activeTap]="productFilter.status || 0"
		></app-tabs>

		<button
			(click)="exportProductsToExcel()"
			class="py-[10px] px-24px rounded-6px border-[1px] border-secondry-color-Gray"
		>
			<img
				class="inline-block mx-[5px]"
				src="./assets/images/export.svg"
				alt=""
			/>
			<span class="font-DIN-Medium text-dark-grey text-font-14">{{
				'STORE.PRODUCT_LIST.EXPORT_PRODUCTS_SHEET' | translate
			}}</span>
		</button>
	</div>

	<!-- table -->
	<app-products-table
		*ngIf="productsList.length"
		[productsList]="productsList"
		[totalCount]="totalCount"
		[productFilter]="productFilter"
	></app-products-table>
</div>
<app-no-data-found
	*ngIf="!productsList.length"
	[imageName]="'shop.svg'"
></app-no-data-found>
<!-- pagination -->
<div class="mt-8 py-5 max-mobile:overflow-auto">
	<app-pagination
		[totalCount]="totalCount"
		[pageNumber]="productFilter?.paging?.pageNumber"
		[pageCount]="productFilter?.paging?.pageSize"
		(currentPage)="pagingChanged($event, productFilter?.paging?.pageSize)"
		(itemsCountPerPage)="pagingChanged(1, $event)"
	></app-pagination>
</div>
<ng-container>
	<mat-sidenav-container [hasBackdrop]="true" class="z-20">
		<mat-sidenav
			position="end"
			#sidenav
			mode="side"
			opened
			class="max-w-[428px] bg-white text-dark-grey p-12px min-h-screen"
			[fixedInViewport]="true"
			[fixedTopGap]="0"
			[disableClose]="false"
			[fixedBottomGap]="0"
			[disableClose]="false"
			[opened]="false"
		>
			<header class="tw-p-4 p-12px">
				<div class="rtl:text-left ltr:text-right">
					<button (click)="sidenav.toggle()">
						<img src="./assets/images/close-square.svg" alt="" />
					</button>
				</div>
			</header>
			<app-products-filter
				#filter
				(emitFilterCount)="filterCount = $event"
				(emitFilter)="
					getProductsList(true, $event); getActiveCount(true); sidenav.toggle()
				"
			></app-products-filter>
		</mat-sidenav>
	</mat-sidenav-container>
</ng-container>

<!-- fixed button -->
<app-fixed-button
	(clickEvent)="FabNavigation()"
	[buttonWidth]="190"
	[buttonTitle]="'STORE.PRODUCT_LIST.ADD_PRODUCT'"
	[imgPath]="'add-white.svg'"
></app-fixed-button>
